import { useEffect, useState } from 'react';

type DashboardFetchResponse<T> = {
    work?: T[];
    tasks?: T[];
    users?: T[];
};

type RowsKey = 'work' | 'tasks' | 'users';

export function useAllRowsForFilter<T>(
    totalCount: number,
    fetchPage: (page: number, resultsPerPage: number) => Promise<DashboardFetchResponse<T>>,
    rowsKey: RowsKey
): T[] {
    const [ allRows, setAllRows ] = useState<T[]>([]);

    useEffect(() => {
        if (totalCount <= 0) {
            setAllRows([]);
            return;
        }

        let cancelled = false;

        fetchPage(1, totalCount).then((response) => {
            if (!cancelled) {
                setAllRows(response[rowsKey] ?? []);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [ totalCount, rowsKey ]);

    return allRows;
}
